import React from "react";
import { SignUp as ClerkSignUp } from "@clerk/clerk-react";

export const SignUp: React.FC = () => {
  return (
    <div className="h-full flex items-center justify-center py-12">
      <div className="w-full max-w-md px-4 sm:px-6 lg:px-8">
        <ClerkSignUp 
          appearance={{
            elements: {
              formButtonPrimary: 'bg-indigo-600 hover:bg-indigo-700 text-white',
              card: 'shadow-lg rounded-lg',
            }
          }}
          redirectUrl="/organizations"
        />
      </div>
    </div>
  );
};
